<template>
  <div class="pa-5">
    <span class="head_text">Update Inventory </span>
    <div>
      <span class="font-16 mt-1">
        Find your product to update your stock.
      </span>
    </div>

    <div>
      <v-row class="mt-6">
        <v-col cols="12" md="6" sm="6">
          <v-card flat style="color: #f2f3f9">
            <v-text-field
              dense
              outlined
              prepend-inner-icon="mdi-magnify"
              label="Search"
              v-model="search"
              @input="searchData();"
              single-line
            >
            </v-text-field>
          </v-card>
        </v-col>
        <v-col cols="12" md="3" sm="6">
          <v-card flat>
            <v-select
              :items="GetProductCategories"
              single-line
              item-text="Category.CategoryName"
                item-value="Category.Id"
              dense
              attach
              outlined
              checkbox
              prepend-inner-icon="mdi-tune"
              label="Categories"
              clearable
              v-model="filterCategories"
              @input="fetchData()"
            >
            </v-select>
          </v-card>
        </v-col>
      </v-row>
      <v-data-table
        class="pl-0 pr-0"
        :headers="headers"
        :loading="tableLoader"
        :items="GetProductsUpdateInventory"
        :page.sync="page"
        :items-per-page="displayedItemsPerPage"
        @page-count="pageCount = $event"
        hide-default-footer
      >
        <template v-slot:[`item.index`]="{ index }">
          <b class="index_index_text"> {{ index + displayedItemsPerPage * (page - 1) + 1 }} </b>
        </template>
        <template v-slot:[`item.name`]="{ item }">
          <div style="display: flex; align-items: center" class="px-2 pa-2">
            <v-avatar v-if="typeof item.CoverImage == 'string'" tile>
              <img :src="item.CoverImage" alt="John" />
            </v-avatar>
            <v-avatar tile v-else>
              <v-icon>mdi-account-off-outline</v-icon>
            </v-avatar>
            <div>
              <p class="mb-0 mx-3 index-head">
                {{ item.ProductName }}
              </p>
            </div>
          </div>
        </template>
        <template v-slot:[`item.Category`]="{ item }">
          <span class="index_head_text">
            {{ item.Category.CategoryName }}
          </span>
        </template>

        <template v-slot:[`item.addstoke`]="{ item }">
          <input
            type="number"
            v-model="item.addItem"
            name=""
            id=""
            style="
              background-color: #ecf1f2;
              height: 40px;
              width: 80px;
              border-radius: 5px;
            "
          />
        </template>
        <template v-slot:[`item.removestoke`]="{ item }">
          <input
            type="number"
            v-model="item.removableItem"
            name=""
            id=""
            style="
              background-color: #ecf1f2;
              height: 40px;
              width: 80px;
              border-radius: 5px;
            "
          />
        </template>
      </v-data-table>
    </div>
    <v-card flat class="my-4 d-flex justify-end align-center">
      <span class="text_transform pa-0 ma-0">Per page : </span>
      <v-card flat width="100" class="mx-5">
        <v-select
          :items="ItemsPerPageItems"
          label="Items per page"
          v-model="itemsPerPage"
          @input="handleItemPerPageChange"
        ></v-select>
      </v-card>
      <v-pagination
        v-model="page"
        :length="pageCount"
        :total-visible="5"
        @input="fetchData"
      ></v-pagination
    ></v-card>
    <div class="d-flex justify-end mx-5 pt-5 pb-10">
      <v-btn depressed text color="#A1A1A6" class="px-5 pr-5" @click="close()">
        Cancel
      </v-btn>
      <v-btn
        depressed
        color="primary"
        class="px-10"
        :disabled="btnloader"
        @click="updateinvetory()"
      >
        <span v-if="btnloader != true">UPDATE ALL STOCK</span>
        <v-progress-circular
          indeterminate
          v-else
          size="20"
          class="px-5"
          color="white"
          v-show="btnloader"
        ></v-progress-circular>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: ["productList"],
  components: {},
  data() {
    return {
      btnloader:false,
      tableLoader: false,
      ItemsPerPageItems: [10, 50, 100, 200, "All"],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      Permission: {},
      isPlaying: false,
      search: "",
      filterCategories: "",
      filterItem: ["Banner", "Books", "Manuals", "Brochures"],
      headers: [
        { text: "#", value: "index" },
        { text: "Product", value: "name" },
        { text: "Category", value: "Category" },
        { text: "Add Stock", value: "addstoke" },
        { text: "Remove Stock", value: "removestoke" },
      ],
      DataTableOne: [],
    };
  },
  computed:{
    ...mapGetters(["GetProductCategories","GetProductsUpdateInventory"]),
    displayedItemsPerPage() {
      return this.itemsPerPage === "All"
        ? this.GetProductsUpdateInventory.length
        : this.itemsPerPage;
    },
  },
  mounted() {
    // this.tableLoader = true;
    setTimeout(() => {
      (this.DataTableOne = [
        {
          index: 1,
          name: "BodyTalk Access Banner",
          category: "US",
          addstoke: "0",
          removestoke: "0",
        },
        {
          index: 123,
          name: "BodyTalk Access Banner",
          category: "US",
          addstoke: "0",
          removestoke: "0",
        },
        {
          index: 123,
          name: "BodyTalk Access Banner",
          category: "US",
          addstoke: "0",
          removestoke: "0",
        },
        {
          index: 123,
          name: "BodyTalk Access Banner",
          category: "US",
          addstoke: "0",
          removestoke: "0",
        },
        {
          index: 123,
          name: "BodyTalk Access Banner",
          category: "US",
          addstoke: "0",
          removestoke: "0",
        },
        {
          index: 123,
          name: "BodyTalk Access Banner",
          category: "US",
          addstoke: "0",
          removestoke: "0",
        },
        {
          index: 123,
          name: "BodyTalk Access Banner",
          category: "US",
          addstoke: "0",
          removestoke: "0",
        },
        {
          index: 123,
          name: "BodyTalk Access Banner",
          category: "US",
          addstoke: "0",
          removestoke: "0",
        },
        {
          index: 123,
          name: "BodyTalk Access Banner",
          category: "US",
          addstoke: "0",
          removestoke: "0",
        },
        {
          index: 123,
          name: "BodyTalk Access Banner",
          category: "US",
          addstoke: "0",
          removestoke: "0",
        },
      ]),
        (this.tableLoader = false);
    }, 1500);
    this.fetchData()
  },
  methods: {
    fetchData() {
      const obj = {
        search: this.search,
        page: this.page,
        pageSize: this.itemsPerPage,
        filters: this.filterCategories?JSON.stringify([{key:"Category",value:this.filterCategories}]): ""
        // filters: JSON.stringify(this.filtersArray),
      };
      this.tableLoader = true;
      this.$store.dispatch("GetProductsUpdateInventory", obj).then((res) => {
        this.tableLoader = false;
        if (this.itemsPerPage !== "All") {
          this.pageCount = Math.ceil(res.TotalRecords / this.itemsPerPage);
        } else {
          this.pageCount = 1;
        }
      });
    },
    handleItemPerPageChange() {
      this.page = 1;
      this.fetchData();
    },
    searchData(){
      this.page=1
      this.fetchData()
    },
    close() {
      this.$emit("close");
    },
    updateinvetory() {
      let selectedData = this.GetProductsUpdateInventory
        .filter((x) => x.addItem || x.removableItem)
        .map((x) => {
          const { addItem, removableItem, Id } = x;
          return { Add: addItem, Remove: removableItem, ProductId: Id };
        });
        this.btnloader=true;
      this.$store.dispatch("UpdateStoreInventory", selectedData).then((res) => {
        if (res.Status) {
          this.SuccessToast = true;
          this.$swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Update successfully",
            showConfirmButton: false,
            timer: 1500,
          });
          this.$emit("close");
          this.btnloader=false;
        } else {
          this.btnloader=false;
          this.$swal.fire({
            toast: true,
            position: "top-end",
            icon: "error",
            title: "Something went wrong",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    },
    closeDialog() {
      this.value = false;
    },
    toggleIsPlaying(obj) {
      this.DataTableOne = this.DataTableOne.map((e) => {
        if (e.index === obj) {
          e.isPlaying = !e.isPlaying;
          return e;
        }
        return e;
      });
      this.isPlaying = !this.isPlaying;
    },
    toggleIsPin(obj) {
      this.DataTableOne = this.DataTableOne.map((e) => {
        if (e.index === obj) {
          e.ispin = !e.ispin;

          return e;
        }
        return e;
      });

      this.ispin = !this.ispin;
    },
    DdialogClose() {
      this.Dialog = false;
      this.ErrorToast = true;
      setTimeout(() => {
        this.ErrorToast = false;
      }, 1500);
    },
  },
};
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: #e0e0e0;
}
.head_text {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 31px;

  /* Color/General/Black High Emphasis */

  color: #222222;
}
.font-16 {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;

  display: flex;
  align-items: center;

  color: rgba(34, 34, 34, 0.7);
}

.text-inside-card {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;

  color: rgba(8, 8, 22, 0.38);
}
</style>
